import type { HourReporterMembershipViewModel, MemberSummary } from "../../../memberships/api/hour-reporter-membership"
import { ReporterDetails } from "./types"

export const getMemberById = (memberId: string, members: MemberSummary[]): MemberSummary => {
  return members.find((member) => member.id === memberId) || members[0]
}

export const getReporterDetails = (
  memberId: string,
  memberships: HourReporterMembershipViewModel[]
): ReporterDetails => {
  return memberships.reduce<ReporterDetails>(
    (details, membership) => {
      if (membership.checkers.some((checker) => checker.id === memberId)) {
        details.checkedReporters.push(membership)
      }

      if (membership.approvers.some((approver) => approver.id === memberId)) {
        details.approvedReporters.push(membership)
      }

      return details
    },
    { checkedReporters: [], approvedReporters: [] }
  )
}
